<template>
    <card>
        <Button type="primary" @click="black()">
            <Icon type="chevron-left"></Icon>
            返回
        </Button>

        <div style="margin-top: 16px"></div>

        <div v-for="offset in  Math.ceil(dataList.length/col)" :key="offset">
            <row>
                <!--  //利用js list取指定元素 指定元素 坐标就是第几行的第一个 第一行第一个就是0 偏移量.(0, 4)-->
                <Col :span="24/col" v-for="(item,index) in (dataList.slice((offset-1)*col, (offset-1)*col+col))"
                     :key="index" style="justify-content: space-between">
                    <Button v-if="item.bps_id === '1'" style="background-color: #ffad33;margin: 5% 5% 5% 0%;font-size: 24px;
                        padding: 10%;min-width: 180px;min-height:88px; border-radius: 4px;color: white" class="k"
                            @click="pathBodySymptoms(item.bid, item.bps_name, item.symptom)">
                        {{ item.bps_name }}
                    </Button>
                    <Button v-if="item.bps_id === '0'" style="background-color: #ffad33;margin: 5% 5% 5% 0%;font-size: 24px;
                        padding: 10%;min-width: 180px;min-height:88px; border-radius: 4px;color: red" class="k"
                            @click="pathBodySymptoms(item.bid, item.bps_name, item.symptom)">
                        {{ item.bps_name }}
                    </Button>
                </Col>
            </row>
        </div>
    </card>
</template>

<script>
    export default {
        data() {
            return {
                col: 4,
                dataList: [],
            };
        },
        created() {
            localStorage.setItem("selectedList", '0');
            this.getBodyPartsList();
        }, methods: {
            getBodyPartsList() {
                this.abHttpUtil
                    .post("/form/formCustSql/view/list_bodySymptoms", {
                        curPage: 1,
                        pageSize: 100,
                        params: {queryData: [{name: "id_", con: "=", val: this.$route.query.id_}]}
                    })
                    .then(
                        (result) => {
                            this.dataList = result.data.list;
                        },
                        function (status) {
                            if (status == !0) {
                                this.$Message.error("加载失败！" + status);
                            }
                        }
                    );
            },
            black() {
                this.$router.push({
                    path: "/LeadingExamining",
                });
            },
            pathBodySymptoms(id_, bps_name, symptom) {
                if (symptom === '0') {
                    this.$router.push({
                        path: "/SymptomsDescribed",
                        query: {
                            id_: id_,
                            name: bps_name,
                        },
                    });
                } else {
                    this.$router.push({
                        path: "/SymptomsDescribedSubmit",
                        query: {
                            id_: id_,
                            name: bps_name,
                            bid_: this.$route.query.id_,
                        },
                    });
                }
            },
        },
    }
</script>

<style scoped>
    .news_container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .news-content {
        color: red;
    }

    .k {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
